import * as React from 'react';
import { AppModel } from '@journeyapps-platform/lib-journey-core';
import { AzureDevopsSourceMetadata, SourceType } from '@journeyapps-platform/types-source-service';
import { useSystem } from '../../../hooks/useSystem';
import { AzureReposSourceControlSubStepWidget } from '../create-app/source-control/azure/AzureReposSourceControlSubStepWidget';
import { CommonMigrateToWidget } from './CommonMigrateToWidget';

export interface MigrateAppToGithubWidgetProps {
  app: AppModel;
  close: () => any;
  createIntegration: () => any;
}

export const MigrateAppToAzureWidget: React.FC<MigrateAppToGithubWidgetProps> = (props) => {
  const { app } = props;
  const system = useSystem();

  return (
    <CommonMigrateToWidget<AzureDevopsSourceMetadata>
      {...props}
      provider={SourceType.AzureDevops}
      generateSource={() => {
        return {
          type: SourceType.AzureDevops,
          properties: {
            organization: '',
            project: '',
            repo: ''
          }
        };
      }}
      generateMigrateWidget={({ payload, setPayload }) => {
        return (
          <AzureReposSourceControlSubStepWidget
            createIntegration={() => {
              props.createIntegration();
            }}
            org={props.app.org}
            name={app.model.name}
            payload={payload}
            payloadChanged={(payload) => {
              setPayload(payload);
            }}
            system={system}
          />
        );
      }}
    />
  );
};
